import StatusBoleto from '@/models/enums/StatusBoleto';
import { IPromessa } from '@/models/IPromessa';
import { BusinessRules } from '../BusinessRules';

import compMsgAcompanhamentoBoletoPosEntrada from '../components/midway/msgAcompanhamentoBoletoPosEntrada.vue';
import compMsgBoletoSemOperacao from '../components/midway/msgBoletoSemOperacao.vue';
import compMsgErroRegerarParcela from '../components/midway/msgErroRegerarParcela.vue';
import standardRules from './standard-rules';

function propostaPreColchao(proposta: IPromessa) {
  const DATA_INICIO_OPERANDO_COLCHAO = new Date('2023-10-17T00:00:00.000-03:00');

  if (proposta?.dataProposta) {
    return proposta.dataProposta < DATA_INICIO_OPERANDO_COLCHAO;
  }

  return false;
}

const rules: Partial<BusinessRules> = {
  disponibilizarSomentePrimeiraParcela: (p) => propostaPreColchao(p),
  compMsgBoletoSemOperacao,
  compMsgAcompanhamentoBoletoPosEntrada,
  compMsgErroRegerarParcela,
  mensagemBoletoEmFilaEmissao: 'O boleto estará disponível próximo à data do vencimento.',
  mostrarAvisoNegociadoComValorAdicional: true,
  permiteNegociacaoParcial: true,
  validatePropostaShowDesconto: (p) => standardRules.validatePropostaShowDesconto(p)
    && !p.detalheDescricao?.includes('apenas as parcelas vencidas'),
  mostrarErroRegerarParcela: (b) => b.status === StatusBoleto.Vencido
    && b.linhaDigitavel == null && b.url == null,
  mensagemAcompanhamentoAplicativo: 'Após o pagamento da entrada, o restante da sua negociação poderá ser acompanhado diretamente no site, aplicativo, ou em qualquer loja da Midway.',
};

export default rules;
